import { render, staticRenderFns } from "./photoAlbum.vue?vue&type=template&id=697ec2ef&scoped=true&"
import script from "./photoAlbum.vue?vue&type=script&lang=ts&"
export * from "./photoAlbum.vue?vue&type=script&lang=ts&"
import style0 from "./photoAlbum.vue?vue&type=style&index=0&id=697ec2ef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697ec2ef",
  null
  
)

export default component.exports